import { collection, addDoc, getDocs, query, orderBy, limit, serverTimestamp } from 'firebase/firestore';
import { db } from '@/lib/firebase';

export const ADMIN_IDS = ['font', 'yok', 'admin'];

export const ALL_USERS = [
  { id: 'font',  name: 'Font',  role: 'admin' },
  { id: 'yok',   name: 'Yok',   role: 'admin' },
  { id: 'admin', name: 'Admin', role: 'admin' },
  { id: 'game',  name: 'Game',  role: 'user'  },
  { id: 'benz',  name: 'Benz',  role: 'user'  },
  { id: 'plai',  name: 'Prai',  role: 'user'  },
  { id: 'ice',   name: 'Ice',   role: 'user'  },
  { id: 'mild',  name: 'Mild',  role: 'user'  },
];

export const ACTION_META = {
  checkin:            { label: 'เช็คอิน',           color: '#16a34a' },
  checkout:           { label: 'เช็คเอาท์',         color: '#dc2626' },
  leave_request:      { label: 'ยื่นใบลา',           color: '#7c3aed' },
  expense_claim:      { label: 'เบิกค่าใช้จ่าย',    color: '#d97706' },
  retro_log:          { label: 'บันทึกย้อนหลัง',    color: '#0284c7' },
  attendance_approve: { label: 'อนุมัติเวลาทำงาน',   color: '#16a34a' },
  attendance_reject:  { label: 'ปฏิเสธเวลาทำงาน',   color: '#dc2626' },
  leave_approve:      { label: 'อนุมัติใบลา',        color: '#16a34a' },
  leave_reject:       { label: 'ปฏิเสธใบลา',        color: '#dc2626' },
  expense_approve:    { label: 'อนุมัติเบิกจ่าย',   color: '#16a34a' },
  expense_reject:     { label: 'ปฏิเสธเบิกจ่าย',   color: '#dc2626' },
  event_create:       { label: 'สร้าง Event',        color: '#0ea5e9' },
  event_delete:       { label: 'ลบ Event',           color: '#dc2626' },
  event_update:       { label: 'แก้ไข Event',        color: '#f59e0b' },
  inventory_create:   { label: 'เพิ่มสินค้า',        color: '#0ea5e9' },
  inventory_update:   { label: 'แก้ไขสินค้า',        color: '#f59e0b' },
  inventory_delete:   { label: 'ลบสินค้า',           color: '#dc2626' },
  inventory_receive:  { label: 'รับสินค้าเข้า',       color: '#16a34a' },
  inventory_dispense: { label: 'เบิกสินค้าออก',      color: '#7c3aed' },
  inventory_return:   { label: 'คืนสินค้า',          color: '#0284c7' },
  party_create:       { label: 'เพิ่มคู่ค้า',         color: '#0ea5e9' },
  party_update:       { label: 'แก้ไขคู่ค้า',         color: '#f59e0b' },
  doc_create:         { label: 'สร้างเอกสาร',        color: '#2563eb' },
  doc_update:         { label: 'แก้ไขเอกสาร',        color: '#f59e0b' },
  doc_delete:         { label: 'ลบเอกสาร',           color: '#dc2626' },
  doc_status:         { label: 'เปลี่ยนสถานะเอกสาร',  color: '#0284c7' },
  payment_confirm:    { label: 'ยืนยันเงินรับ',       color: '#16a34a' },
  payment_reject:     { label: 'ปฏิเสธเงินรับ',       color: '#dc2626' },
  payment_link:       { label: 'ผูกเงินรับกับคู่ค้า',  color: '#0ea5e9' },
  venue_create:       { label: 'เพิ่มสถานที่',        color: '#0ea5e9' },
  venue_update:       { label: 'แก้ไขสถานที่',        color: '#f59e0b' },
  venue_delete:       { label: 'ลบสถานที่',           color: '#dc2626' },
  salesdoc_upload:    { label: 'อัปโหลดเอกสาร',       color: '#0ea5e9' },
  salesdoc_delete:    { label: 'ลบเอกสาร',            color: '#dc2626' },
  chatguide_update:   { label: 'แก้ไขไกด์ตอบแชท',     color: '#f59e0b' },
};

export async function logActivity(userId, userName, action, detail = '') {
  try {
    await addDoc(collection(db, 'activity_logs'), {
      userId, userName, action, detail,
      createdAt: serverTimestamp(),
    });
  } catch (e) {
    console.warn('logActivity failed:', e.message);
  }
}

export async function getActivityLogs(limitCount = 50) {
  const snap = await getDocs(
    query(collection(db, 'activity_logs'), orderBy('createdAt', 'desc'), limit(limitCount))
  );
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
